import { User } from '../../interfaces/user.interface'
import requestBack from '../config/request-back'
import { requireInformedRequesterId } from '../utils/requester'

const createCompany = async (authData: any) => {
	const informedRequesterId = requireInformedRequesterId(authData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = authData ?? {}

	let response = await requestBack({
		method: 'POST',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/new-company`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true
	})

	return response
}


const patchCompany = async (authData: any) => {
	const informedRequesterId = requireInformedRequesterId(authData?.informedRequesterId)
	const { informedRequesterId: _ignoredRequesterId, ...payload } = authData ?? {}

	let response = await requestBack({
		method: 'PATCH',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/patch-company`,
		data: {
			...payload,
			informedRequesterId,
		},
		vtAuth: true,
	})

	return response
}


const getCompanyById = async (companyId: any) => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/company-by-id/${companyId}`,
		vtAuth: true,
	})

	return response
}

const getAdminsByCompany = async (company_id: string): Promise<User[]> => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/admins-by-company/${company_id}`,
		vtAuth: true,
	});

	return response;
}

const getAllCompanies = async () => {
	let response = await requestBack({
		method: 'GET',
		url: process.env.REACT_APP_SERVICES_BACK_HOST + `/all-companies`,
		vtAuth: true,
	})

	return response
}


export { createCompany, patchCompany as updateCompany, getCompanyById as getCompanyId, getAdminsByCompany, getAllCompanies }
